/**
 * Display discount price math — the single JS implementation.
 *
 * Mirrors the Liquid in snippets/display-discount-window.liquid's callers exactly:
 * floor the discount in cents PER UNIT, then multiply by quantity. Order matters —
 * flooring the line total instead differs by a cent at some quantities.
 *
 * Loaded globally (layout/theme.liquid) rather than from the PDP section, because
 * collection grids, the side cart and search all need it and window.Theme used to
 * exist only on product pages.
 */
(function () {
  window.Theme = window.Theme || {};

  /**
   * Discounted unit price, in cents.
   * @param {number|string} unitCents - undiscounted unit price in cents
   * @param {number|string} percentOff - percentage off, e.g. 15
   * @returns {number} discounted unit price in cents
   */
  Theme.discountedUnitCents = function (unitCents, percentOff) {
    var cents = parseInt(unitCents, 10);
    var pct = parseFloat(percentOff);
    // Pass an unusable price straight through rather than substituting 0 — returning 0 here
    // would render the product as free, which is far worse than the caller's own NaN.
    if (!isFinite(cents)) return Number(unitCents);
    if (!isFinite(pct) || pct <= 0) return cents;
    // Clamp at zero: a mistyped entry (percent_off: 150) would otherwise render a negative
    // price, which is never a correct display for any surface.
    return Math.max(0, cents - Math.floor((cents * pct) / 100));
  };

  /**
   * Merchant-authored fixed unit price string ("$3.49") to integer cents.
   * @param {string} discountPrice
   * @returns {number|null} cents, or null when unset/unparseable
   */
  Theme.discountFixedUnitCents = function (discountPrice) {
    if (discountPrice == null || discountPrice === '') return null;
    var n = parseFloat(String(discountPrice).replace(/[^0-9.]/g, ''));
    return isFinite(n) ? Math.round(n * 100) : null;
  };
})();
